import { v2 } from '@saucelabs/sl-module-builds';

import { NAMESPACE } from './types';
import * as selectors from './selectors';

const operations = v2.buildsList.operations.createRDCOperations(NAMESPACE, selectors);
export default operations;
